<template>
  <div class="documents-list">
    <div class="divTable unstyledTable">
      <div class="divTableHeading">
        <div class="divTableRow">
          <div class="divTableCell width-999 pl-10 font-bold docTblHeading">
            Agreement Documents
          </div>
          <!-- Fake table cell -->
          <div class="divTableCell"></div>
          <div class="divTableCell"></div>
          <div class="divTableCell"></div>
          <div class="divTableCell"></div>
          <div class="divTableCell"></div>
          <div class="divTableCell"></div>
        </div>
        <div class="divTableRow">
          <div class="divTableHead" :class="field.class" v-for="(field, index) in documentListFields" :key="index">
            <b class="mr-5">{{ field.label }}</b>
            <span class="sortDown mr-2" v-if="field.label !== 'Action'" @click="sortField(field, 'asc')" :class="{ 'disable-icon': !field.ascOrder }"><i class="fa fa-long-arrow-down" aria-hidden="true"></i></span>
            <span class="sortUp" v-if="field.label !== 'Action'" @click="sortField(field, 'desc')" :class="{ 'disable-icon': !field.descOrder }"><i class="fa fa-long-arrow-up" aria-hidden="true"></i></span>
          </div>
        </div>
      </div>
      <div class="divTableBody" v-for="(document, index) in documents" :key="index">
        <div class="divTableRow">
          <div class="divTableCell pl-20 action text-info" :title="document.docName">
            <router-link :to="getNextRoute('mainDocument', document, null, false)" :event="'click'" @click.native="getNextRoute('mainDocument', document, null, true)" class="document_name">{{ getDocumentName(document.docName, 19) }} </router-link>
          </div>
          <div class="divTableCell pl-10 action color-text fs-12">
            <span v-if="document.datavantConsent == true">
              <span v-if="document.status == 'SignedByParticipant'">Active</span>
              <span v-else-if="document.status == 'Declined'">Active(Declined)</span>
            </span>
            <span v-else-if="document.platformDocId !=null && document.state == 'Active'">{{document.state}}</span>
            <span v-else-if="document.state == 'Inactive'">{{document.state}}</span>
          </div>
          <div class="divTableCell pl-10 action language_color">
            {{ document.docLanguageName }}
          </div>
          <div class="divTableCell pl-10">
            <div
              v-if="(document.status == 'SignatureNotRequested' || document.status == 'RequestedSignature') && document.state != 'Inactive' && !(participantData.status === 'ACTIVEWITHOUTAPP')"
              v-on="!loading && (document.configured || isESignRequired) && document.allowRequestSign ? { click: () => showReqSignModal(document) } : {}"
              :class="{
                disabled: !document.configured ? (isESignRequired ? false : true) : !document.allowRequestSign ? true : false,
                signature: document.status == 'SignatureNotRequested'
              }"
            >
              <a
                v-if="document.status == 'SignatureNotRequested'"
                @click="setStatus(document.status)"
                :disabled="!document.configured ? (isESignRequired ? false : true) : !document.allowRequestSign ? true : false"
                :class="{
                  disabled: loading || (!document.configured ? (isESignRequired ? false : true) : !document.allowRequestSign ? true : false)
                }"
                >Request Signature</a
              >
              <span v-else-if="document.status == 'RequestedSignature'">
                <a
                  class="doc_request resend"
                  @click="setStatus(document.status)"
                  :class="{
                    disabled: loading || (!document.configured ? (isESignRequired ? false : true) : !document.allowRequestSign ? true : false)
                  }"
                  >Resend</a
                >
                <a class="doc_request cancel" @click.stop="showCancelRequestModal(document)">Cancel</a>
              </span>
            </div>
            <div v-if="document.isParticipantSigned && document.participantSignedTime > 0" class="pt-8 pb-8">
              <span class="color-text fs-12">{{ new Date(document.participantSignedTime) | formatUTCDate }}</span>
              <span class="clock" v-bind:id="`document.participantSignedTime${index}`" tabindex="0"></span>
              <b-popover v-bind:target="`document.participantSignedTime${index}`" triggers="click blur">
                <template v-slot:content>
                  <div class="popover-content" v-if="document.participantSignedTime">
                    <span class="person"></span>
                    <div class="ml-20 w-170 text-uppercase" v-html="participantLocalTimeFormat(document)"></div>
                  </div>
                  <div class="popover-content" v-if="document.participantSignedTime != 0">
                    <span class="clinic"></span>
                    <div class="ml-20 w-170 text-uppercase" v-html="toUserLocalTime(document.participantSignedTime)"></div>
                  </div>
                </template>
              </b-popover>
            </div>
          </div>
          <div class="divTableCell">
            <div v-if="document.isPISignRequired">
              <span class="color-text fs-12" v-if="!document.isPISigned">Not Signed</span>
              <span class="color-text fs-12" v-if="document.isPISigned">
                <span class="color-text fs-12">{{ new Date(document.piSignedTime) | formatUTCDate }}</span>
                <span class="clock" v-bind:id="`document.piSignedTime${index}`" tabindex="0"></span>
                <b-popover v-bind:target="`document.piSignedTime${index}`" triggers="click blur">
                  <template v-slot:content>
                    <div class="popover-content">
                      <span class="clinic"></span>
                      <div class="ml-20 w-170 text-uppercase" v-html="toUserLocalTime(document.piSignedTime)"></div>
                    </div>
                  </template>
                </b-popover>
              </span>
            </div>
            <div class="sign-in-wrap" v-if="!document.isPISignRequired">
              <span class="color-text fs-12">N/A</span>
            </div>
          </div>
          <div class="divTableCell pl-10 action">
            <div v-if="document.uploadedTime">
              <span class="color-text fs-12">{{ new Date(document.uploadedTime) | formatUTCDate }}</span>
              <span class="clock" v-bind:id="`document.uploadedTime${index}`" tabindex="0"></span>
              <b-popover v-bind:target="`document.uploadedTime${index}`" triggers="click blur">
                <template v-slot:content>
                  <div class="popover-content">
                    <span class="clinic"></span>
                    <div class="ml-20 w-170 text-uppercase" v-html="toUserLocalTime(document.uploadedTime)"></div>
                  </div>
                </template>
              </b-popover>
            </div>
          </div>
          <div class="divTableCell pl-10 action text-info">
            <button class="btn btn-light addDoc" v-if="(document.platformDocId != null && document.state == 'Active') || (document.platformDocId != null && document.state == 'Inactive')" @click="openUploadDocModal(document)">
              Upload Document
            </button>
          </div>
        </div>

        <div v-for="(cdocument, index) in document.childDocs" :key="index" class="divTableRow">
          <div class="divTableCell pl-10 width-870 action text-info">
            <span class="pl-20">
              <img src="static/img/vector-arrow/child-arrow@2x.png" class="vector" />
              <router-link :to="getNextRoute('mainDocument', cdocument, null, false)" :event="'click'" @click.native="getNextRoute('mainDocument', cdocument, null, true)" class="document_name">
                <span class="pl-8" :title="cdocument.docName">{{ getDocumentName(cdocument.docName, 17) }}</span>
              </router-link>
            </span>
          </div>
          <div class="divTableCell pl-10 action text-info"></div>
          <div class="divTableCell pl-10 action language_color">
            {{ cdocument.docLanguageName }}
          </div>
          <div class="divTableCell pl-10 action">
            <span class="fs-12 color-text" v-if="cdocument.participantSignDate">{{ cdocument.participantSignDate | CustomdateUTC }}</span>
          </div>
          <div class="divTableCell pl-0 action">
            <span class="fs-12 color-text" v-if="cdocument.siteMemberSignDate">{{ cdocument.siteMemberSignDate | CustomdateUTC }}</span>
          </div>
          <div class="divTableCell pl-10 action">
            <span class="fs-12 color-text" v-if="cdocument.uploadedTime">{{ cdocument.uploadedTime | CustomdateFUTC }} UTC</span>
          </div>
          <div class="divTableCell pl-10 action"></div>
        </div>

        <!-- invalidate document  -->
        <div v-for="(cdocument, index) in document.invalidatedParticipantDocumentList" :key="index" class="divTableRow">
          <div class="divTableCell pl-10 width-870 action text-info">
            <span class="pl-20">
              <img src="static/img/vector-arrow/child-arrow@2x.png" class="vector" />
              <router-link :to="getNextRoute('invalidatedDocument', document, cdocument, false)" :event="'click'" @click.native="getNextRoute('invalidatedDocument', document, cdocument, true)" class="document_name">
                <span class="pl-8" :title="cdocument.docName">{{ getDocumentName(cdocument.docName, 17) }}</span>
              </router-link>
            </span>
          </div>
          <div class="divTableCell pl-10 action text-danger">Invalidated</div>
          <div class="divTableCell pl-10 action language_color">
            {{ cdocument.languageId }}
          </div>
          <div class="divTableCell pl-10 action">
            <span class="fs-12 color-text" v-if="cdocument.participantSignDate">{{ new Date(cdocument.participantSignDate) | formatUTCDate }}</span>
          </div>
          <div class="divTableCell pl-0 action">
            <span class="fs-12 color-text" v-if="cdocument.siteMemberSignDate">{{ new Date(cdocument.siteMemberSignDate) | formatUTCDate }}</span>
          </div>
          <div class="divTableCell pl-10 action">
            <span class="fs-12 color-text" v-if="cdocument.uploadedTime">{{ new Date(cdocument.uploadedTime) | formatUTCDate }}</span>
          </div>
          <div class="divTableCell pl-10 action"></div>
        </div>
      </div>
    </div>
    <div class="no-task slide-animation" v-if="enableNoData">
      No documents available to view
    </div>
    <!-- Modal Component -->
    <b-modal ref="reqSignModalRef" id="requestSignModal" hide-footer hide-header>
      <p class="fs-16 p-10">
        Are you sure you want to request signature for
        <b class="docName_wrap">{{ selectedDoc.docName }}</b
        >?
      </p>
      <b-col cols="10" offset="1" class="pt-10">
        <b-btn class="br-30" variant="primary" block @click="requestSignature('resend', 'reqSignModalRef')">Yes, send request</b-btn>
      </b-col>
      <b-col cols="10" offset="1" class="pb-20">
        <b-btn class="mt-20 br-30" size="md" variant="secondary" block @click="hideModal('reqSignModalRef')">No, do not send request</b-btn>
      </b-col>
    </b-modal>

    <!-- Cancel a Signature Request Modal Starts -->
    <b-modal ref="cancelRequestModalRef" id="cancelRequestModal" size="lg" hide-footer hide-header>
      <div>
        <p class="fs-20 p-10">
          Are you sure you want to cancel this signature request?
        </p>
        <b-row>
          <b-col cols="6" class="">
            <b-btn class="mt-15 br-30 cancel" size="md" block @click="hideModal('cancelRequestModalRef')">Cancel</b-btn>
          </b-col>
          <b-col cols="6" class="">
            <b-btn class="mt-15 br-30 yes" block @click="requestSignature('cancelRequest', 'cancelRequestModalRef')">Yes</b-btn>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <!-- Cancel a Signature Request Modal Ends -->

    <div id="upload-document-modal" class="modal fade" role="dialog" data-backdrop="static">
      <div class="modal-dialog pl-50">
        <!-- Modal content-->
        <div class="modal-content pl-34">
          <div>
            <div class="modal-header border-none">
              <div class="doc-modal-title">Upload Document</div>
              <button type="button" class="close" @click="closeModal">
                &times;
              </button>
            </div>
            <div class="modal-body pl-0 pr-30">
              <form>
                <div class="file-upload-document">
                  <label class="alignlable">
                    <span v-if="fileName" id="fileName" class="spanFile1">
                      <span :title="fileName" class="spanFile1" v-if="fileName.length >= 32">{{ fileName.slice(0, 30) }}...</span>
                      <span :title="fileName" v-else>{{ fileName }}</span>
                    </span>
                    <span v-else class="spanFile">Select Document</span>
                    <span v-if="fileName.length == 0" class="btnBrowse0">Browse</span>
                    <span v-else :class="fileName.length >= 34 ? 'btnBrowse' : 'btnBrowse2'">Browse</span>
                    <input type="file" class="file-input form-control" size="60" id="consent_section_doc" v-on:change="onDocFileSelection($event)" accept="application/pdf" />
                  </label>
                </div>
                <div class="form-group">
                  <label class="labelTitle">Document Language</label>
                  <select v-model="selectedLanguage" class="language-select-box form-control">
                    <option value="null" disabled selected>Choose Language</option>
                    <option :value="lang.language_id" v-for="lang in studyLanguages" :key="lang.language_id">{{ lang.display_name }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="labelTitle">Participant Sign Date</label>
                  <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Participant Sign Date" v-model="participantSignDate" format="MM/dd/yyyy" calendar-button-icon="fa fa-calendar-o" name="participantSignDate">
                    <template slot="afterDateInput">
                      <span class="cal-icon-style">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                      </span>
                    </template>
                  </datepicker>
                </div>
                <div class="form-group">
                  <label class="labelTitle">Site Team Sign Date</label>
                  <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Site Team Sign Date" v-model="siteMemberSignDate" format="MM/dd/yyyy" name="siteMemberSignDate">
                    <template slot="afterDateInput">
                      <span class="site-cal-icon-style">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                      </span>
                    </template>
                  </datepicker>
                </div>
                <div class="form-group">
                  <label class="labelTitle">Signed By</label>
                  <select v-model="signedBy" class="language-select-box form-control">
                    <option value="">Select Team Member</option>
                    <option v-for="team in siteTeamList" :value="team.id" :key="team.id"
                      >{{ team.firstName }} {{ team.lastName }},
                      <span v-if="team.userRole == 'Pi'">PI</span>
                      <span v-if="team.userRole == 'SubPi'">Sub-I</span>
                      <span v-if="team.userRole == 'StudyCoordinator'">SC</span>
                      <span v-if="team.userRole == 'HomeHealth'">HH</span>
                    </option>
                  </select>
                </div>
                <a class="btn additional-signers-btn" v-if="!showMoreFields" @click="showExtraFields"> + Add additional signers</a>
                <div class="addiotional-signers" v-if="showMoreFields">
                  <div class="form-group positioned">
                    <div class="upper-text-container">
                      <label class="labelTitle">Parent/Legal Guardian/Caregiver Sign Date</label>
                      <a class="btn add-btn ml-auto" @click="addAdditionalRoleSigner('parent')" v-if="!additionalParentAdded">+ add</a>
                    </div>
                    <datepicker :calendar-button-icon-content="'fa fa-calendar-o'" class="text-left datepicker-container" input-class="datepicker-class uploadDocInputField form-control" placeholder="Parent/Legal Guardian/Caregiver Sign Date" v-model="parentOneSignDate" format="MM/dd/yyyy" name="parentOneSignDate">
                      <template slot="afterDateInput">
                        <span class="site-cal-icon-style">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        </span>
                      </template>
                    </datepicker>
                  </div>
                  <div class="form-group positioned" v-if="additionalParentAdded">
                    <div class="upper-text-container">
                      <label class="labelTitle">Parent/Legal Guardian/Caregiver #2 Sign Date</label>
                    </div>
                    <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Parent/Legal Guardian/Caregiver #2 Sign Date" v-model="parentTwoSignDate" format="MM/dd/yyyy" name="parentTwoSignDate">
                      <template slot="afterDateInput">
                        <span class="site-cal-icon-style">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        </span>
                      </template>
                    </datepicker>
                  </div>
                  <div class="form-group positioned">
                    <div class="upper-text-container">
                      <label class="labelTitle">Observer Sign Date</label>
                      <a class="btn add-btn ml-auto" @click="addAdditionalRoleSigner('observer')" v-if="!additionalObserverAdded">+ add</a>
                    </div>
                    <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Observer Sign Date" v-model="observerOneSignDate" format="MM/dd/yyyy" name="observerOneSignDate">
                      <template slot="afterDateInput">
                        <span class="site-cal-icon-style">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        </span>
                      </template>
                    </datepicker>
                  </div>
                  <div class="form-group positioned" v-if="additionalObserverAdded">
                    <div class="upper-text-container">
                      <label class="labelTitle">Observer #2 Sign Date</label>
                    </div>
                    <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Observer #2 Sign Date" v-model="observerTwoSignDate" format="MM/dd/yyyy" name="observerTwoSignDate">
                      <template slot="afterDateInput">
                        <span class="site-cal-icon-style">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        </span>
                      </template>
                    </datepicker>
                  </div>
                  <div class="form-group positioned">
                    <div class="upper-text-container">
                      <label class="labelTitle">Witness Sign Date</label>
                      <a class="btn add-btn ml-auto" @click="addAdditionalRoleSigner('witness')" v-if="!additionalWitnessAdded">+ add</a>
                    </div>
                    <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Witness Sign Date" v-model="witnessOneSignDate" format="MM/dd/yyyy" name="witnessOneSignDate">
                      <template slot="afterDateInput">
                        <span class="site-cal-icon-style">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        </span>
                      </template>
                    </datepicker>
                  </div>
                  <div class="form-group positioned" v-if="additionalWitnessAdded">
                    <div class="upper-text-container">
                      <label class="labelTitle">Witness #2 Sign Date</label>
                    </div>
                    <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Witness #2 Sign Date" v-model="witnessTwoSignDate" format="MM/dd/yyyy" name="witnessTwoSignDate">
                      <template slot="afterDateInput">
                        <span class="site-cal-icon-style">
                          <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        </span>
                      </template>
                    </datepicker>
                  </div>
                </div>
                <div class="align-right">
                  <button type="button" @click="uploadDocument()" :disabled="isDisabled" class="btn btn-primary btnUpload float-right">
                    Upload
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import _ from "lodash";
import Datepicker from "vuejs-datepicker";
import localStorageService from "@/services/localStorage";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import { mapGetters } from "vuex";
import { STUDY_ADMIN, STUDY_MANAGER, BSTAT, PHV, SITEDATALOCK } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import toastr from "toastr";

export default {
  name: "DocumentsList",
  props: ["toggleFeatures"],
  data() {
    return {
      loading: false,
      studyId: this.$route.params.studyId,
      participantId: this.$route.params.participantId,
      documents: [],
      totalDocuments: 0,
      participantSignDate: "",
      siteMemberSignDate: "",
      parentOneSignDate: "",
      parentTwoSignDate: "",
      observerOneSignDate: "",
      observerTwoSignDate: "",
      witnessOneSignDate: "",
      witnessTwoSignDate: "",
      showMoreFields: false,
      additionalParentAdded: false,
      additionalObserverAdded: false,
      additionalWitnessAdded: false,
      signedBy: "",
      siteId: null,
      siteDetails: [],
      siteTeamList: [],
      DatePickerFormat: "dd/MM/yyyy",
      isDisabled: false,
      documentListFields: [
        {
          key: "docName",
          type: "string",
          label: "Document Name",
          ascOrder: false,
          descOrder: false,
          class: "width-520 pl-10",
          currentOrder: null
        },
        {
          key: "state",
          type: "string",
          label: "Status",
          ascOrder: false,
          descOrder: false,
          class: "width-395 pl-10",
          currentOrder: null
        },
        {
          key: "docLanguageName",
          type: "string",
          label: "Language",
          ascOrder: false,
          descOrder: false,
          class: "width-395 pl-10",
          currentOrder: null
        },
        {
          key: "participantSignedTime",
          type: "integer",
          label: "Participant Signed",
          ascOrder: false,
          descOrder: false,
          class: "width-990 pl-10",
          currentOrder: null
        },
        {
          key: "piSignedTime",
          type: "integer",
          label: "Site Signed",
          ascOrder: false,
          descOrder: false,
          class: "width-1909",
          currentOrder: null
        },
        {
          key: "uploadedTime",
          type: "integer",
          label: "Uploaded",
          ascOrder: false,
          descOrder: false,
          class: "width-1000 pl-10",
          currentOrder: null
        },
        { label: "Action", class: "width-326 pl-10", currentOrder: null }
      ],
      selectedDoc: {},
      selectedLanguage: null,
      studyLanguages: [],
      file: "",
      fileName: "",
      fileEvent: "",
      enableNoData: false,
      participantData: "",
      currentStatus: ""
    };
  },
  components: { datepicker: Datepicker },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    isESignRequired() {
      //check site country and study flag
      const isESignEnabled = _.find(this.toggleFeatures, {
        featureKey: "ElectronicSignature",
        enabled: true
      });

      if (isESignEnabled !== undefined && this.participantData.countryName.toLowerCase().indexOf("denmark") !== -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  filters: {
    // We create the Date obj with moment because the native new Date()
    // does not work on Safari with the date format we receive from backend.
    CustomdateUTC(value) {
      if (value) {
        const date = moment(value, "YYYY-MM-DD HH:mm:ss").toDate();
        return momentTimeZone(date).format("MMM DD, YYYY");
      }
    },
    CustomdateFUTC(value) {
      if (value) {
        const date = moment(value, "YYYY-MM-DD HH:mm:ss").toDate();
        return momentTimeZone(date).format("MMM DD, YYYY hh:mm A");
      }
    }
  },
  methods: {
    addAdditionalRoleSigner(role) {
      switch (role) {
        case "parent":
          this.additionalParentAdded = true;
          break;
        case "observer":
          this.additionalObserverAdded = true;
          break;
        case "witness":
          this.additionalWitnessAdded = true;
          break;
      }
    },
    showExtraFields() {
      this.showMoreFields = true;
    },
    showReqSignModal(doc) {
      if (!doc.configured && !this.isESignRequired) {
        return;
      }
      if (this.canStudyAdminAccess || this.canStudyManagerAccess || this.canBioStatisticsAccess || this.canPharmacovigilanceAccess || this.user.userRole === "Cra" || this.user.userRole === "SiteDataLock" || this.user.readOnly || this.user.userRole === "CraUB") {
        toastr.warning("Access restricted");
      } else {
        this.selectedDoc = doc;
        this.$refs.reqSignModalRef.show();
      }
    },
    openUploadDocModal(document) {
      if (this.canStudyAdminAccess || this.canStudyManagerAccess || this.canSiteDataLockAccess || this.canBioStatisticsAccess || this.canPharmacovigilanceAccess || this.user.readOnly) {
        toastr.warning("Access restricted");
      } else {
        this.selectedLanguage = "";
        this.file = "";
        this.fileName = "";
        this.fileEvent = "";
        this.participantSignDate = "";
        this.siteMemberSignDate = "";
        this.signedBy = "";
        this.parentOneSignDate = "";
        this.parentTwoSignDate = "";
        this.observerOneSignDate = "";
        this.observerTwoSignDate = "";
        this.witnessOneSignDate = "";
        this.witnessTwoSignDate = "";
        this.showMoreFields = false;
        this.additionalParentAdded = false;
        this.additionalObserverAdded = false;
        this.additionalWitnessAdded = false;
        this.getPaticipantDetail();
        this.getSiteTeamFact();
        this.document = document;
        this.getSiteInfo(document.studyId, this.siteId);
        window.$("#upload-document-modal").modal("show");
      }
    },
    getSiteId() {
      const user = localStorageService.getItem("userObj");
      if (user && user.siteIds && user.siteIds.length) {
        this.siteId = user.siteIds[0];
      }
    },
    getDocuments() {
      const docObj = {
        studyId: this.studyId,
        participantId: this.participantId
      };
      nprogress.start();
      this.$api.documentsListFact(docObj).then(
        response => {
          let list = [];
          list = response.body;
          const result = list.filter(item => item.parentDocId == null);
          result.forEach(function(item) {
            const a = list.filter(x => x.parentDocId == item.docId);
            item.childDocs = a;
            if(item.docName.toLowerCase().trim() == "datavant tokenization consent" && item.siteId == null && item.consentId) {
              item.datavantConsent = true;
            }
            else {
              item.datavantConsent = false;
            }
          });
          const filteredList = result.filter(item => item.state != "Uploaded");
          this.documents = filteredList;
          this.documents = this.sortTimeStamp("asc", {
            key: "studyId"
          });
          this.totalDocuments = this.documents.length;
          this.enableNoData = this.documents.length == 0;
          this.loading = false;
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.loading = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting documents.");
        }
      );
    },
    documentSelected(document, fromInvalidCol = false) {
      if (this.canStudyAdminAccess || this.canStudyManagerAccess || this.canBioStatisticsAccess || this.canPharmacovigilanceAccess) {
        toastr.warning("Access restricted");
      } else {
        this.$router.push({
          name: "participant-document",
          params: {
            studyId: this.studyId,
            participantId: this.participantId,
            documentId: document.docId,
            inValidateDocumentId: fromInvalidCol ? document.id : false
          }
        });
        if (document.isParticipantSignatureProcessing) {
          toastr.warning("Participant responses are being processed. This may take a few moments.");
        } else {
          this.$router.push({
            name: "participant-document",
            params: {
              studyId: this.studyId,
              participantId: this.participantId,
              documentId: document.docId
            }
          });
        }
      }
    },
    hideModal(modalRef) {
      this.$refs[modalRef].hide();
    },
    closeModal() {
      window.$("#upload-document-modal").modal("hide");
    },
    sortField(field, direction) {
      const statusList = this.documents.filter(el => {
        return el.state;
      });
      const languagesList = this.documents.filter(el => {
        return el.docLanguageName;
      });
      if (field.label == "Status" && statusList.length == 0) {
        field.ascOrder = false;
        field.descOrder = false;
      } else if (field.label == "Language" && languagesList.length == 0) {
        field.ascOrder = false;
        field.descOrder = false;
      } else {
        if (direction == "asc") {
          field.ascOrder = true;
          field.descOrder = false;
        } else if (direction == "desc") {
          field.ascOrder = false;
          field.descOrder = true;
        }
        if (field.type == "string") {
          if (field.currentOrder != direction) {
            field.currentOrder = direction;
            this.documents = this.sortString(direction, field);
          }
        } else if (field.type == "integer" && field.currentOrder != direction) {
          field.currentOrder = direction;
          this.documents = this.sortTimeStamp(direction, field);
        }
      }
    },
    sortString(direction) {
      let records = _.cloneDeep(this.documents);
      records = _.orderBy(records, [records => records.docName.toLowerCase()], direction);
      return records;
    },
    sortTimeStamp(direction, field) {
      let records = _.cloneDeep(this.documents);
      records = _.orderBy(records, field.key, direction);
      return records;
    },
    getSiteInfo(studyId, siteId) {
      this.$api.getSiteDetailsFact(studyId, siteId).then(response => {
        this.siteDetails = response.body;
      });
    },
    getStudyLanguages() {
      this.$api.getStudyLanguages(this.studyId).then(
        response => {
          this.studyLanguages = response.body;
          if (this.studyLanguages.length > 1) {
            this.selectedLanguage = null;
          } else if (this.studyLanguages != null && this.studyLanguages.length == 1) {
            this.selectedLanguage = this.studyLanguages[0].language_id;
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting Study Languages.");
        }
      );
    },
    getPaticipantDetail() {
      this.studyLanguages = [];
      this.selectedLanguage = "";
      this.$api.getParticipantDataFact(this.studyId, this.participantId).then(
        response => {
          this.participantData = response.body;
          this.studyLanguages.push(response.body.participantLanguage);
          this.selectedLanguage = this.studyLanguages[0].language_id;
          if (!this.siteId) {
            this.siteId = response.body.siteId;
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting Study Languages.");
        }
      );
    },
    getSiteTeamFact() {
      this.$api.getSiteTeamFact(this.studyId, this.siteId).then(response => {
        this.siteTeamList = response.body;
      });
    },
    onDocFileSelection(event) {
      if (!(event.srcElement || (event.srcElement.files && event.srcElement.files[0] == null))) {
        return true;
      }
      this.fileEvent = event;
      this.file = event.srcElement.files[0];
      this.fileName = this.file.name;
      event.target.value = null;
    },

    uploadDocument() {
      nprogress.start();
      this.isDisabled = false;
      let error = false;
      if (this.fileEvent) {
        if (!(this.fileEvent.srcElement || (this.fileEvent.srcElement.files && this.fileEvent.srcElement.files[0] == null))) {
          return true;
        }
      }

      if (!this.selectedLanguage || this.selectedLanguage === undefined || this.selectedLanguage === "" || this.selectedLanguage === "null") {
        this.$toastr.error("Please select a document language.");
        return;
      }

      if (!this.file || this.file === undefined || this.file === "") {
        this.$toastr.error("No file selected!!");
        return;
      }

      if (this.file) {
        const ext = this.file.name
          .split(".")
          .pop()
          .toLowerCase();

        this.fileName = this.file.name;

        if (ext != "pdf") {
          error = true;
          this.$toastr.error("PDF files only");
          return;
        }

        if (this.file) {
          const fileSizeMB = this.formatBytes(this.file.size);
          if (fileSizeMB > 100) {
            error = true;
            this.$toastr.error("File size cannot exceed 100 MB.");
            return;
          }
        }
      }

      if (error) {
        if (this.studyLanguages.length > 1) {
          this.selectedLanguage = null;
        } else if (this.studyLanguages != null && this.studyLanguages.length == 1) {
          this.selectedLanguage = this.studyLanguages[0].language_id;
        }
        return;
      }
      const pIutcMoment = moment(this.participantSignDate).utcOffset(this.getLocalOffset());
      const participantSignDateUTC = momentTimeZone(pIutcMoment)
        .tz("UTC")
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
      const fd = new FormData();
      fd.append("studyId", this.document.studyId);
      fd.append("siteId", this.siteId);
      fd.append("participantId", this.document.participantId);
      fd.append("documentName", this.fileName);
      fd.append("languageId", this.selectedLanguage);
      fd.append("participantSignDate", this.participantSignDate ? moment(this.participantSignDate).format("YYYY-MM-DDTHH:mm:ss[Z]") : "");
      fd.append("siteMemberSignDate", this.siteMemberSignDate ? moment(this.siteMemberSignDate).format("YYYY-MM-DDTHH:mm:ss[Z]") : "");
      fd.append("parentOneSignDate", this.parentOneSignDate ? moment(this.parentOneSignDate).format("YYYY-MM-DDTHH:mm:ss[Z]") : "");
      fd.append("parentTwoSignDate", this.parentTwoSignDate ? moment(this.parentTwoSignDate).format("YYYY-MM-DDTHH:mm:ss[Z]") : "");
      fd.append("observerOneSignDate", this.observerOneSignDate ? moment(this.observerOneSignDate).format("YYYY-MM-DDTHH:mm:ss[Z]") : "");
      fd.append("observerTwoSignDate", this.observerTwoSignDate ? moment(this.observerTwoSignDate).format("YYYY-MM-DDTHH:mm:ss[Z]") : "");
      fd.append("witnessOneSignDate", this.witnessOneSignDate ? moment(this.witnessOneSignDate).format("YYYY-MM-DDTHH:mm:ss[Z]") : "");
      fd.append("witnessTwoSignDate", this.witnessTwoSignDate ? moment(this.witnessTwoSignDate).format("YYYY-MM-DDTHH:mm:ss[Z]") : "");
      fd.append("signedBy", this.signedBy);
      fd.append("file", this.file);
      fd.append("parentDocId", this.document.docId);
      fd.append("participantSignDateUTC", participantSignDateUTC);

      this.$api.saveStudyParticipantDocuement(this.document.studyId, this.siteId, this.document.participantId, fd).then(
        () => {
          nprogress.done();
          this.isDisabled = false;
          this.getDocuments();
          this.$toastr.success("Document uploaded successfully");
          window.$("#upload-document-modal").modal("hide");
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body ? error.body.message : "Error while adding the research site document");
        }
      );
    },
    formatBytes(size) {
      return size / Math.pow(1024, 2);
    },
    toUserLocalTime(timeString) {
      const localObj = moment.utc(timeString).local();
      const formatedTime = localObj.format("DD MMM YYYY hh:mm");
      const meridiem = localObj.format("A");

      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      return `${formatedTime} ${meridiem} ${abbr}`;
    },
    participantLocalTimeFormat(record) {
      const d = moment(record.participantSignedTime).utcOffset(record.participantOffset);
      return moment(d).format("DD MMM YYYY hh:mm A");
    },
    getLocalOffset() {
      const offset = new Date().getTimezoneOffset();
      const o = Math.abs(offset);
      return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
    },
    getDocumentName(documentName, docNameLength) {
      if (documentName.length >= docNameLength) {
        return documentName.split(".")[0].slice(0, docNameLength - 2) + "...";
      } else {
        return documentName.split(".")[0];
      }
    },
    getNextRoute(docType, document, cdocument, showToaster) {
      let route = {
        // route to participant-profile
        name: "participant-profile",
        params: { participantId: this.participantId }
      };
      if (this.canStudyAdminAccess || this.canStudyManagerAccess || this.canBioStatisticsAccess || this.canPharmacovigilanceAccess) {
        if (showToaster) {
          toastr.warning("Access restricted.");
        }
      } else if (document.isParticipantSignatureProcessing) {
        if (showToaster) {
          toastr.warning("Participant responses are being processed. This may take a few moments.");
        }
      } else {
        if (docType === "mainDocument") {
          // route to main documents
          route = {
            name: "participant-document",
            params: {
              studyId: this.studyId,
              participantId: this.participantId,
              documentId: document.docId
            }
          };
        } else {
          route = {
            // route to invalid documents
            name: "participant-document",
            query: {
              inValidateDocumentId: cdocument.id
            },
            params: {
              studyId: this.studyId,
              participantId: this.participantId,
              documentId: document.docId
            }
          };
        }
      }
      return route;
    },
    showCancelRequestModal(doc) {
      if (this.canStudyAdminAccess || this.canStudyManagerAccess || this.canBioStatisticsAccess || this.canPharmacovigilanceAccess || this.user.userRole === "Cra" || this.user.userRole === "SiteDataLock" || this.user.readOnly || this.user.userRole === "CraUB") {
        toastr.warning("Access restricted");
      } else {
        this.selectedDoc = doc;
        this.$refs.cancelRequestModalRef.show();
      }
    },
    requestSignature(req, modalRef) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const currentDate = new Date();
      let docData = {
        studyId: this.studyId,
        participantId: this.participantId,
        docId: this.selectedDoc.docId,
        reqSignDate: moment.utc(currentDate).format()
      };
      if (req === "resend" && this.currentStatus != "SignatureNotRequested") {
        docData = req ? { ...docData, resend: true } : docData;
      }
      if (req === "cancelRequest") {
        docData = req ? { ...docData, cancelRequest: true } : docData;
      }
      this.$api.requestSignatureFact(docData).then(
        data => {
          this.getDocuments();
          this.$toastr.success(req ? data["bodyText"] : "Request for signature sent.");
        },
        error => {
          this.loading = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting documents.");
        }
      );
      this.hideModal(modalRef);
    },
    setStatus(status) {
      this.currentStatus = status;
    }
  },
  mounted() {
    this.getDocuments();
    this.getSiteId();
    this.getPaticipantDetail();
  }
};
</script>
<style scoped lang="scss" src="@/assets/table-styling.scss"></style>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
<style scoped lang="scss">
.positioned {
  position: relative;
}

.datepicker-class {
  content: "->";
  border: 1px solid red !important;
}

.upper-text-container {
  display: flex;
  align-items: center;
}
.additional-signers-btn {
  font-size: 14px;
  color: #1e8fe1 !important;
  background: transparent;
  width: 100%;
  text-align: left;
}

.add-btn {
  font-size: 14px;
  color: #1e8fe1 !important;
  background: transparent;
  width: 100%;
  text-align: left;
  flex: 2;
  padding-right: 0;
  text-align: right;
}
.documents-list {
  padding: 0px 20px;
  margin-bottom: 10px;
  .signature {
    width: 129px;
    height: 30px;
    padding: 4px 0px 0px 14px;
    font-family: Roboto-Regular;
    font-size: 14px;
    border-radius: 4px;
    border: solid 1px #e4e8eb;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4c8ce4;
    cursor: pointer;
    a {
      color: #4c8ce4;
      font-size: 12px;
      font-weight: bold;
      cursor: pointer;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.disabled {
      cursor: not-allowed;
    }
  }
  .doc_request {
    width: 129px;
    height: 30px;
    padding: 7px 22px 6px 21px;
    font-family: Roboto-Regular;
    border-radius: 4px;
    border: solid 1px #e4e8eb;
    color: #4c8ce4;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;

    &.resend {
      color: #4c8ce4;
      margin-right: 8px;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.cancel {
      color: #959fa4;
    }
  }
  .action {
    font-family: Roboto-Regular;
    cursor: pointer;
  }
  .text-info {
    font-family: Roboto-Regular;
    color: #1e8fe1 !important;
    cursor: pointer;
    font-weight: 600;
  }
  .color-text {
    color: #a8a8a8;
  }
  .clock {
    margin-top: -4px;
    margin-left: 4px;
  }
  .addDoc {
    color: #4c8ce4;
    font-size: 14px;
    font-weight: bold;
    width: 169px;
    height: 30px;
    border-radius: 4px;
    border: solid 1px #e4e8eb;
    background-color: #ffffff;
    padding-top: 3px;
  }
  .doc-modal-title {
    width: 360px;
    height: 24px;
    padding-top: 20px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 1.2;
    color: #666669;
  }
  .modal-content {
    width: 425px;
    height: auto;
    max-height: 766px;
    overflow-y: auto;
    border-radius: 4px;
    background-color: #ffffff;
  }
  .modal-title {
    margin: auto;
    margin-top: 45px;
    text-align: center;
    width: 100%;
    font-family: Roboto-Bold;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #666669;
  }
  .disabled_datepicker {
    pointer-events: none;
    opacity: 0.5;
    .datepicker-class {
      background-color: #eee !important;
    }
  }

  .cov-datepicker {
    width: 100%;
  }

  .icon_style {
    position: absolute;
    height: 33px;
    display: inline-block;
    border-left: 1px solid #ddd;
    top: 21px;
    right: 16px;
    background-color: rgba(85, 85, 85, 0.05);
    width: 35px;
    pointer-events: none;
  }
  .cal-icon-style {
    position: absolute;
    cursor: pointer;
    pointer-events: none;
    color: #b0bac9;
    right: 8px;
    top: 8px;
    height: 14px;
    width: 14px;
  }
  .upload-document-modal {
    .modal-dialog {
      overflow-y: initial !important;
    }
  }
  .site-cal-icon-style {
    position: absolute;
    cursor: pointer;
    pointer-events: none;
    color: #b0bac9;
    top: 8px;
    right: 8px;
    height: 14px;
    width: 14px;
  }
  .vdp-datepicker {
    > div {
      position: relative;
    }
  }
  .cal-icon {
    position: absolute;
    color: #b0bac9;
    cursor: pointer;
    top: 57%;
    left: 341px;
  }

  // .observer-cal-icon-style{
  //   position: absolute;
  //   color: #b0bac9;
  //   cursor: pointer;
  //   top: 523px;
  //   z-index: 100;
  //   left: 342px;
  // }

  .language-select-box {
    width: 360px;
    max-width: 100%;
    height: 40px;
    border-radius: 3px;
    box-shadow: inset 0 1px 2px 0 #e4e8eb;
    border: solid 1px #e4e8eb;
    background-color: #ffffff;
    background-image: url(/static/img/arrow-down.png) !important;
    font-family: Roboto-Regular;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #9b9b9b;
  }
  .uploadDocInputField {
    margin-top: 12px;
    width: 360px;
    height: 40px;
    border-radius: 3px;
    box-shadow: inset 0 1px 2px 0 #e4e8eb;
    border: solid 1px #e4e8eb;
    background-color: #ffffff;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #9b9b9b;
  }
  .form-group {
    margin-top: 12px;
  }

  .file-input {
    display: none;
    flex-grow: 2;
    border: none;
  }

  span.btnBrowse {
    padding: 2px 19px 6px 25px;
    margin: -25px 4px -2px 62px;
    width: 100px;
    height: 28px;
    border-radius: 4px;
    border: solid 1px #1e8fe1;
    color: #1e8fe1;
    float: right;
  }

  span.spanFile {
    padding-right: 145px;
    color: #9b9b9b;
    width: auto;
  }
  .spanFile1 {
    color: #9b9b9b;
    width: auto;
    margin-top: 12px;
  }
  .file-upload-document {
    display: flex;
    background: #fff;
    height: 36px;
    align-items: end;
    justify-content: flex-end;
    width: 100%;
    height: 40px;
    border-radius: 3px;
    box-shadow: inset 0 1px 2px 0 #e4e8eb;
    border: solid 1px #e4e8eb;
    background-color: #ffffff;
    padding-top: 9px;
  }
  .btnUpload {
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 30px;
    margin-right: 0px;
    background-color: #1e8fe1;
  }
  .labelTitle {
    font-weight: bold;
  }
  .statusActive {
    padding: 1px 9px 1px 7px;
    height: 16.2px;
    font-weight: 600;
    border-radius: 2px;
    border: solid 1px #e4e8eb;
    background-color: #f7f7f7;
  }
  .statusInactive {
    color: #4a4a4a;
    padding: 1px 3px 1px 3px;
    font-weight: 600;
    opacity: 0.6;
    border-radius: 2px;
    border: solid 1px #e4e8eb;
    background-color: #f7f7f7;
  }
  .width-520 {
    width: 520px;
  }
  .width-870 {
    width: 870px;
  }
  .width-999 {
    width: 1297px;
  }
  .width-990 {
    width: 1010px;
  }
  label.alignlable {
    width: 97%;
  }
  .docTblHeading {
    color: #4a4a4a;
  }
  .width-1000 {
    width: 1717px;
  }
  .width-1909 {
    width: 1909px;
  }
  .vector {
    width: 7px;
    height: 11.3px;
    object-fit: contain;
    margin-bottom: 6px;
  }
  span.btnBrowse2 {
    padding: 2px 19px 6px 25px;
    margin: -4px 4px -2px 0px;
    width: 100px;
    height: 29px;
    border-radius: 4px;
    border: solid 1px #1e8fe1;
    color: #1e8fe1;
    float: right;
  }
  span.btnBrowse0 {
    padding: 3px 19px 6px 25px;
    margin: -25px 4px -4px 0px;
    width: 100px;
    height: 30px;
    border-radius: 4px;
    border: solid 1px #1e8fe1;
    color: #1e8fe1;
    float: right;
  }
  .language_color {
    opacity: 0.5;
    font-family: Roboto-Regular;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4a4a4a;
  }
}
.document_name {
  &:hover {
    text-decoration: none;
  }
}
@media screen and (min-width: 0\0) {
  /* supports all versions of Internet Explorer */
  span.btnBrowse0 {
    padding: 3px 19px 6px 25px !important;
    margin: -2px 4px -5px 0px !important;
    width: 100px;
    height: 28px !important;
    border-radius: 4px;
    border: solid 1px #1e8fe1;
    color: #1e8fe1;
    float: right;
  }
}
@media not all and (min-resolution: 0.001dpcm) {
  .signature {
    width: 129px;
    height: 30px;
    padding: 6px 0px 0px 9px !important;
    font-family: Roboto-Regular;
    font-size: 14px;
    border-radius: 4px;
    border: solid 1px #e4e8eb;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4c8ce4;
  }
}
popover-content {
  position: relative;
  color: #4a4a4a;
  font-family: Roboto-Regular;
  font-size: 14px;
  opacity: 0.7;
  div {
    display: inline-block;
  }
  span {
    display: inline-block;
    width: 12px;
    height: 11px;
    background-repeat: no-repeat;
    position: absolute;
    top: 5px;
    &.clinic {
      background-image: url(/static/img/date-clinic-icon.svg);
    }
  }
}
/* if document name is too big. this css property will break the word to overcome the outside flow of word */
.docName_wrap {
  word-wrap: break-word;
}

/deep/ #cancelRequestModal .modal-body {
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem;
  margin: 1rem 2.8rem 2rem 2.8rem;

  .cancel {
    color: #000;
    font-size: 15px;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    max-width: 75% !important;
    margin-left: 60px;
    padding: 8px;

    &:hover {
      color: #fff;
      background-color: #6c757d;
      border-color: #6c757d;
    }
  }

  .yes {
    color: #fff;
    font-size: 15px;
    background-color: #4c8ce4;
    border-color: #4c8ce4;
    max-width: 75% !important;
    padding: 8px;

    &:hover {
      color: #fff;
      background-color: #007bff;
      border-color: #007bff;
    }
  }
}
</style>
